import api from './axiosInterceptor';

export const authService = {
  // Session-based auth check (keep for backward compatibility)
  getCurrentUser: () => api.get('/api/auth/current-user'),

  // Session logout 
  logout: () => api.get('/api/auth/logout'),

  // JWT methods
  jwtLogin: async (email, password) => {
    const response = await api.post('/api/auth/jwt/login', { email, password });
    if (response.data.accessToken && response.data.refreshToken) {
      localStorage.setItem('accessToken', response.data.accessToken);
      localStorage.setItem('refreshToken', response.data.refreshToken);
    }
    return response;
  },

  jwtRefresh: async (refreshToken) => {
    return api.post('/api/auth/jwt/refresh', { refreshToken });
  },

  jwtLogout: async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    if (refreshToken) {
      try {
        await api.post('/api/auth/jwt/logout', { refreshToken });
      } catch (error) {
        console.error('Logout API failed', error);
      }
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
    }
  },

  getAccessToken: () => localStorage.getItem('accessToken'),
  getRefreshToken: () => localStorage.getItem('refreshToken'),
  clearTokens: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  },
  isAuthenticated: () => {
    return !!localStorage.getItem('accessToken');
  }
};